import { useState, useEffect } from 'react'
import Hero from '../components/Hero'
import Features from '../components/Features'
import DownloadSection from '../components/DownloadSection'
import Footer from '../components/Footer'
import '../styles/LandingPage.css'

function LandingPage() {
  return (
    <div className="landing-page">
      <Hero />
      <Features />
      <DownloadSection />
      <Footer />
    </div>
  )
}

export default LandingPage
